import React from "react";
import { LuChevronDown } from "react-icons/lu";

const options = [10, 25, 50, 100];

type Props = {
  value: number;
  onChange: (value: number) => void;
};

const PageSizeSelect = ({ value, onChange }: Props) => (
  <div className="relative w-20">
    <select
      value={value}
      onChange={(event) => onChange(Number(event.target.value))}
      className="flex h-10 w-20 appearance-none items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>

    <LuChevronDown className="pointer-events-none absolute right-3 top-3 h-4 w-4 opacity-50" />
  </div>
);

export { PageSizeSelect };
export default PageSizeSelect;
